export const loadDashTasks = ({ ...params }) => ({
  type: 'LOAD_DASHTASKS',
  payload: {
    request: {
      method: 'GET',
      url: '/dashtasks',
      ...params
    }
  }
})

export const getDashTaskById = (id) => ({
  type: '@@SOCIETARIO/GET_DASHTASK_BY_ID',
  payload: {
    request: {
      method: 'GET',
      url: `/dashtasks/${id}`,
      showLoading: false
    },
  },
});

export const registerBill = (data) => ({
  type: 'REGISTER_BILL',
  payload: {
    request:{
      method: 'post',
      url:'/extras',
      data: data
    }
  }
});

export const saveBill = (id, data) => ({
  type: 'SAVE_BILL',
  payload: {
    request:{
      method: 'post',
      url:`/extras/${id}`,
      data: data
    }
  }
});